import axios from "axios";
import {handleError} from "@/_helpers/utils";
import {TALENTQ_STORE_NAMES} from "./constants";

export default {
  namespaced: true,
  state() {
    return {
      loaded: false,
      error: null,
      data: null,
    }
  },
  actions: {
    load(context) {
      if (!context.getters.project_id) {
        context.commit('set_data', null);
        context.commit('set_loaded', true);
        context.commit('set_error', null);
        return Promise.resolve();
      }
      context.commit('set_loaded', false);
      context.commit('set_error', null);
      return axios.get(`/1.0/talentq/project/${context.getters.project_id}`)
        .then(response => response.data.data)
        .then(data => {
          context.commit('set_data', data);
          context.commit('set_loaded', true);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_error', err);
          throw err;
        })
    },
  },
  mutations: {
    set_loaded(state, loaded) {
      state.loaded = loaded;
    },
    set_loading(state, loading) {
      state.loading = loading;
    },
    set_error(state, error) {
      state.error = error;
    },
    set_data(state, data) {
      if (data && data.assessments) {
        data.assessments.forEach(assessment => {
          assessment.assessment_code = assessment.assessment_code.id;
          assessment.norm_groups = assessment.norm_groups.map(item => item.norm_group.id);
          assessment.pdf_report_options = assessment.pdf_report_options.map(item => item.pdf_report_option.id);
          assessment.pdf_report_types = assessment.pdf_report_types.map(item => item.pdf_report_type.id);
          assessment.report_options = assessment.report_options.map(item => item.report_option.id);
          assessment.report_scales = assessment.scales.map(item => item.scale.id);
        });
      }
      state.data = data;
    },
  },
  getters: {
    loaded: state => state.loaded,
    error: state => state.error,
    data: state => state.data,
    project_id: (state, getters, rootState, rootGetters) => rootGetters[`vacancy_talentq/${TALENTQ_STORE_NAMES.BINDING}/project_id`],
  }
}